export class DominioTransaccion {
    transaccionEstado: string;
    transaccionListaMensajes: any[];
    auxFlgPreparado: string;
    auxFlgValidado: string;

    auxAccion: string;
    auxFlgNuevo: string;
    auxFlgEditar: string;
    auxFlgEliminar: string;
}